function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import React, { useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { Datalayer } from '@finect/front-gtm';
var Iframe = styled.iframe.withConfig({
  displayName: "Podcast__Iframe",
  componentId: "sc-14urdx7-0"
})(["width:100%;height:198px;border:none;border-radius:8px;"]);
export var normalizePodcast = function normalizePodcast(url) {
  var regex = /https?:\/\/(?:.+?\.)?ivoox\.com\/[^_]*_rf_(.?P*\d+)_\d*\.html/;
  var match = regex.exec(url);
  if (match && match[1]) {
    return {
      vendor: 'ivoox',
      id: match[1]
    };
  }
  return null;
};
var Podcast = function Podcast(_ref) {
  var url = _ref.url;
  var theme = useTheme();
  var _useState = useState('initial'),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var podcast = normalizePodcast(url);
  var handleLoad = function handleLoad() {
    setStatus('success');
  };
  if (podcast) {
    var src = "https://www.ivoox.com/player_ej_".concat(podcast.id, "_6_1.html?c1=").concat(theme.colors.primary.substr(1));
    return React.createElement(React.Fragment, null, status === 'success' ? React.createElement(Datalayer, {
      id: "FiEvent",
      type: "fiEvent",
      params: {
        category: 'Podcast',
        label: 'impression',
        action: "".concat(podcast.vendor, "-").concat(podcast.id)
      }
    }) : null, React.createElement(Iframe, {
      src: src,
      onLoad: handleLoad
    }));
  }
  return null;
};
export default Podcast;